<template>
        <div>
                 <el-dialog
                        title="充值"
                        width="65%"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        充值
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll">
                        <avue-form
                                ref="carChargeFormRef"
                                v-model="form"
                                :option="option"
                                @submit="saveCarCharge"
                                >
                                <template slot="payScene">
                                        <el-select
                                                v-model="form.payScene"
                                                @change="paySceneChange"
                                                placeholder="请选择 收款类型"
                                        >
                                                <el-option
                                                        v-for="item in paySceneList"
                                                        :key="item"
                                                        :value="item.dictKey"
                                                        :label="item.dictValue"
                                                >
                                                </el-option>
                                        </el-select>
                                </template>

                                <template slot="authCode">
                                        <el-input type="password" ref="authCodeInput" v-model="form.authCode"  maxlength="20" placeholder="请输入 收款码"></el-input>
                                </template>
                        </avue-form>
                </div>
                <template slot="footer" v-loading="loading">
                        <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                        <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
                </template>
                <el-dialog
                        :title="payScene==6?'查询中':'收款码'"
                        :visible.sync="showQrCode"
                        :close-on-click-modal="false"
                        width="30%"
                        top="16vh"
                        append-to-body
                        @close="closeQrCode"
                        >
                        <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
                                {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
                        </div>
                        <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
                                扫码支付后请勿手动关闭弹窗
                        </div>
                        <div style="text-align: center">
                                <div id="qrcodeCar" ref="qrcode" style="display: inline-block"></div>
                                <div>倒计时：{{ countdown }}</div>
                        </div>
                </el-dialog>
                </el-dialog>
        </div>
</template>
<script>
import {
        saveCarCharge,
  } from '@/api/v4ward/park/storedValueCarv2/storedValueCar';
import {
        getPaySceneList,
        queryCarCharge
} from '@/api/v4ward/park/vehiclev2/parkvehicle';
import QRCode from "qrcodejs2";
export default {
        props:{
                projectList:{
                        type:Array,
                        default(){
                                return []
                        }
                }
        },
        data(){
                return{
                        showQrCode:false,
                        loading:false,
                        payBillNo:'',
                        data:[],
                        form:{},
                        countdown:120,
                        statusDuration:120,
                        payInfo2:{},
                        paySceneList:[],
                        dialogVisible:false,
                        dialogFull:false,
                        plateNumber:'',
                        timer:'',
                        payStatus:'',
                        page: {
                                pageSize: 10,
                                currentPage: 1,
                                total: 0,
                        },
                        option:{
                                align: 'center',
                                emptyBtn: false,
                                submitText: '保存',
                                submitBtn:false,
                                column: [
                                {
                                        label: '车场名称',
                                        type: 'tree',
                                        prop: 'spaceId',
                                        span: 8,
                                        search: true,
                                        cell: true,
                                        clearable: false,
                                        disabled: true,
                                        props: {
                                                label: 'title',
                                                value: 'key',
                                        },
                                        rules: [
                                                {
                                                message: '请选择车场名称',
                                                required: true,
                                                },
                                        ],
                                        dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',

                                },
                                {
                                        label: '车牌号',
                                        prop: 'plateNumber',
                                        disabled: true,
                                        span: 8,
                                        rules: [
                                                {
                                                required: true,
                                                message: '请选择车牌号',
                                                trigger: 'change',
                                                },
                                        ],
                                },



                                {
                                        label: '余额',
                                        prop: 'carBalance',
                                        precision: 2,
                                        width: 70,
                                        disabled: true,
                                        hide: true,
                                        maxlength: 15,
                                        showWordLimit: true,
                                        mock: {
                                                type: 'number',
                                                max: 1,
                                                min: 2,
                                                precision: 2,
                                        },
                                        rules: [
                                                { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
                                        ],
                                        minRows: 0.01,
                                        span: 8,
                                },
                                {
                                        label: '充值金额',
                                        prop: 'tradeFee',
                                        precision: 2,
                                        width: 70,
                                        hide: true,
                                        maxlength: 12,
                                        showWordLimit: true,
                                        append:'(元)',
                                        mock: {
                                                type: 'number',
                                                max: 1,
                                                min: 2,
                                                precision: 2,
                                        },
                                        rules: [
                                                {
                                                required: true,
                                                message: '请输入充值金额',
                                                trigger: 'change',
                                                },
                                                { pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, message: '格式错误' },
                                        ],
                                        minRows: 0.01,
                                        span: 8,
                                },
                                {
                                        label: '支付方式',
                                        prop: 'payMethod',
                                        span: 8,
                                        viewDisplay: false,
                                        hide: true,

                                        type: 'select',
                                        dicUrl: '/api/blade-system/dict/dictionary?code=car_charge_type',
                                        props: {
                                                label: 'dictValue',
                                                value: 'dictKey',
                                        },
                                        dataType: 'number',
                                        rules: [
                                                {
                                                        required: true,
                                                        message: '请选择支付方式',
                                                        trigger: 'change',
                                                },
                                        ],
                                },
                                {
                                        label: '收款类型',
                                        prop: 'payScene',
                                        type: 'input',
                                        span: 8,
                                        display:false,
                                        disabled: false,
                                        formslot: true,
                                        rules: [
                                                {
                                                required: true,
                                                message: '请选择收款类型',
                                                trigger: 'change',
                                                },
                                        ],
                                },
                                {
                                        label: '收款码',
                                        prop: 'authCode',
                                        type: 'input',
                                        span: 8,
                                        display:false,
                                        disabled: false,
                                        formslot: true,
                                        rules: [
                                                {
                                                required: true,
                                                message: '请选择收款码',
                                                trigger: 'change',
                                                },
                                        ],
                                },
                                {
                                        label: '备注',
                                        prop: 'remark',
                                        hide: true,
                                        span: 24,
                                        type: 'textarea',
                                        minRows: 2,
                                        maxlength: 200,
                                        showWordLimit: true,
                                        overHidden: true,
                                        rules: [
                                                {
                                                required: false,
                                                message: '请输入 备注',
                                                trigger: 'change',
                                                },
                                        ],
                                },
                                ],
                        },


                }
        },
        watch:{
                'form.payMethod'(val){
                        this.form.authCode= '';
                        this.payTypeChange(val);
                }
        },
        methods:{
                openDialog(row){
                        console.log(row)
                        this.form = {
                                vehicleId:row.id,
                                spaceId:row.spaceId,
                                plateNumber:row.plateNumber,
                                carBalance:row.carBalance,
                                remark:'',
                                payMethod:'',
                                tradeFee:'',
                                payScene:'',
                                authCode:'',
                        }
                        setTimeout(()=>{
                                this.$refs.carChargeFormRef.clearValidate()
                        })
                        this.dialogVisible = true;
                },
                formSubmit1(){
                        this.$refs.carChargeFormRef.submit();
                },
                saveCarCharge(form,done){
                        if(parseInt(this.form.payScene)==5){
                                // 二维码
                                this.qrCodePay();
                        }else if(parseInt(this.form.payScene)==6){
                                // 扫码枪
                                this.authCodePay();
                        }else{
                                // 现金
                                this.normalPay();
                        }
                        done();
                        // this.loading = true;
                        // saveCarCharge(form).then(res=>{
                        //         if(res.success){
                        //                 this.$message({
                        //                         type: "success",
                        //                         message: "操作成功!"
                        //                 });
                        //                  this.$emit('onLoad')
                        //                  this.dialogVisible = false;
                        //         }
                        //         this.loading = false;
                        //         done()
                        // }).catch(REs=>{
                        //         this.loading = false;
                        //         done();

                        // })
                },
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {

                                self.dialogVisible = false;

                        })
                        .catch(()=> {

                        });
                },
                // 关闭弹窗
                quitCarChargeDialog(){
                        // this.$refs.carChargeFormRef.resetForm();
                        // this.$message({
                        //         type: "success",
                        //         message: "操作成功!"
                        // });
                        this.$emit('onLoad');
                        this.dialogVisible = false;

                },
                // 支付方式切换
                payTypeChange(val){
                        if(val){
                                this.form.payScene = '';
                                let len = this.$refs.carChargeFormRef.columnOption[0].column.length;
                                this.form.payScene = '';
                                if(parseInt(val)==4 || parseInt(val)==5 || parseInt(val)==6 || parseInt(val)==7){
                                        this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
                                        this.$refs.carChargeFormRef.columnOption[0].column[len-3].display=false;
                                }else{
                                        this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
                                        this.$refs.carChargeFormRef.columnOption[0].column[len-3].display=true;
                                }
                                getPaySceneList({payMethod:val}).then((res)=>{
                                        this.paySceneList = res.data;
                                        console.log(res);
                                });
                        }
                },
                // 收款类型切换
                paySceneChange(val){
                        let len = this.$refs.carChargeFormRef.columnOption[0].column.length;
                        if(parseInt(val)==6){
                                this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=true;
                        }else{
                                this.$refs.carChargeFormRef.columnOption[0].column[len-2].display=false;
                        }
                },
                // 现金支付
                normalPay(){
                        saveCarCharge(this.form, { showLoading: { text: '处理中' } }).then(
                                (data) => {
                                        this.payBillNo = data.data.orderNo;
                                        this.quitCarChargeDialog();
                                        this.$message.success('操作成功!');
                                },
                        (error) => {
                                window.console.log(error);
                        },
                        )
                },
                //关闭二维码
                closeQrCode() {
                        setTimeout(() => {
                                this.$refs.qrcode.innerHTML = '';
                        }, 300);
                        clearInterval(this.timer);
                },
                // 生成收款二维码
                qrCodePay(){
                        saveCarCharge(this.form, { showLoading: { text: '正在获取二维码' } }).then((data) => {
                                this.showQrCode = true;
                                this.payBillNo = data.data.orderNo;
                                this.$nextTick(() => {
                                        new QRCode('qrcodeCar', {
                                                width: 250,
                                                height: 250,
                                                text: data.data.codeUrl,
                                        });
                                });
                                this.showQrCode = true;
                                this.countdown = 120;
                                this.timer = setInterval(() => {
                                        if (this.countdown === 0) {
                                                clearInterval(this.timer);
                                                this.showQrCode = false;
                                                this.$message.info('倒计时结束，二维码弹窗关闭');
                                        }
                                        if (this.countdown % 5 === 0) {
                                                queryCarCharge({ paybillNo: this.payBillNo }).then(({ data }) => {
                                                        this.payStatus = data.tradeType;
                                                        if (parseInt(data.tradeType) == 2) {
                                                                this.showQrCode = false;
                                                                this.$message.success('支付成功');
                                                                this.quitCarChargeDialog();
                                                                clearInterval(this.timer);
                                                        }
                                                });
                                        }
                                        this.countdown--;
                                }, 1000);
                        },
                        (error) => {
                                window.console.log(error);
                        },
                        );
                },
                // 扫码枪付款
                authCodePay(){
                        saveCarCharge(this.form, { showLoading: { text: '正在付款中' } }).then(
                                (data) => {
                                this.payBillNo = data.data.orderNo;
                                this.openMaskAndPollingPayStatus();
                                this.quitCarChargeDialog();

                                this.$message.success('操作成功!');
                        },
                        (error) => {
                                window.console.log(error);
                        },
                        );
                },
                // 扫码枪轮询
                openMaskAndPollingPayStatus() {
                        this.statusDuration = 120;
                        this.statusDialogVisible = true;
                        let timer = setInterval(() => {
                                console.log('this.status==>', this.statusDuration);
                                this.statusDuration--;
                                console.log('this.status==>', typeof this.statusDuration);
                                if (this.statusDuration <= 0) {
                                        this.$message.error('支付失败');
                                        this.statusDialogVisible = false;
                                        clearInterval(timer);
                                        this.statusDuration = 120;
                                        window.location.reload();
                                } else {
                                if (this.statusDuration % 10 == 0 || this.statusDuration == 119) {
                                        queryCarCharge({ paybillNo: this.payBillNo }).then(({ data }) => {
                                                console.log('res pooling  data==>', data);
                                                if (parseInt(data.tradeType) == 2) {

                                                        this.$message.success('支付成功');
                                                        this.statusDialogVisible = false;
                                                        clearInterval(timer);
                                                        this.statusDuration = 120
                                                }
                                        });
                                }
                                }
                        }, 1000);
                },




        }
}
</script>
